import { ConfigProvider, Flex, Tabs, TabsProps } from "antd";
import Title from "antd/es/typography/Title";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CouponList from "./components/CouponList";
import { MemberContext } from "../../../context/MemberProvider.tsx";
import { couponType } from "../../../types/coupon.ts";

const Coupons: React.FC = () => {
  const [currentTab, setCurrentTab] = useState("1");
  const { t } = useTranslation();
  const { memberData } = useContext(MemberContext);

  const [usableData, setUsableData] = useState<couponType[]>([]);
  const [unusableData, setUnusableData] = useState<couponType[]>([]);
  const foregroundColorAlpha = (): string => {
    return memberData?.foreground_color + "B3"; // B3 is 70% opacity
  };

  useEffect(() => {
    if (!memberData) {
      return;
    }

    const inProgress =
      memberData.card_coupons
        ?.filter((order) => order.status === "Usable")
        .slice(0, 100) || [];
    const completed =
      memberData.card_coupons
        ?.filter((order) => order.status !== "Usable")
        .slice(0, 100) || [];

    setUsableData(inProgress);
    setUnusableData(completed);
  }, [memberData]);

  const contents = () => {
    if (!memberData) {
      return null;
    }

    const items: TabsProps["items"] = [
      {
        key: "1",
        label: t("Usable"),
        children: (
          <CouponList
            shopURL={memberData.shop_url}
            data={usableData}
            backgroundColor={memberData.background_color}
          />
        ),
      },
      {
        key: "2",
        label: t("Used/Expired"),
        children: (
          <CouponList
            shopURL={memberData.shop_url}
            unusable
            data={unusableData}
            backgroundColor={memberData.background_color}
          />
        ),
      },
    ];
    return (
      <>
        <Tabs
          defaultActiveKey="1"
          items={items}
          centered
          activeKey={currentTab}
          className="w-full"
          onChange={(e) => setCurrentTab(e)}
        />
      </>
    );
  };

  return (
    memberData && (
      <ConfigProvider
        theme={{
          token: { colorPrimary: memberData.foreground_color },
          components: {
            Tabs: {
              itemColor: "#8C9CAB",
              itemHoverColor: foregroundColorAlpha(),
            },
          },
        }}
      >
        <Flex data-testid="coupon" vertical className="w-full min-h-[85vh]">
          <Title
            level={2}
            style={{
              paddingTop: "12px 16px 0 16px",
              position: "sticky",
              top: 0,
              zIndex: "10",
            }}
            className="h2-bold bg-white p-4"
          >
            {t("My Coupon")}
          </Title>
          {contents()}
        </Flex>
      </ConfigProvider>
    )
  );
};
export default Coupons;
